// @flow

import Game from '@/lib/game';
import Cell from '@/lib/cell';
import Settings from '@/lib/settings';

export default class {
  game: Game;
  cells: { [string]: Cell };

  constructor(game: Game) {
    this.game = game;
    this.cells = this.createCells();
  }

  makeCellId(x: number, y: number) {
    return `${x}-${y}`;
  }

  createCells(): { [string]: Cell } {
    return Settings.cellElevations.reduce((acc, row, y) => {
      row.forEach((cellElevation, x) => {
        acc[this.makeCellId(x, y)] = new Cell(this, x, y, cellElevation);
      });

      return acc;
    }, {});
  }

  find(...conditions: any[]): Cell | null {
    switch (conditions.length) {
      case 1:
        return this.cells[conditions[0]] || null;
      case 2:
        return (
          this.cells[this.makeCellId(conditions[0], conditions[1])] || null
        );
    }

    return null;
  }

  valuate(x: number, y: number): number {
    const cell = this.find(x, y);
    if (!cell) return 0;

    const { units } = cell;
    const totalValue = units.reduce((acc, unit) => {
      if (unit.isDead() || unit.isCut()) {
        return 0;
      }

      return acc + unit.valuate();
    }, 0);

    return totalValue;
  }

  /**
   * 該当マスのユニットをすべて削除し、その数を返す
   */
  removeUnits(x: number, y: number): number {
    const cell = this.find(x, y);
    if (!cell) return 0;

    const { units } = cell;
    units.forEach(unit => {
      unit.cut();
    });

    return units.length;
  }

  process() {
    for (let cellId in this.cells) {
      let cell = this.cells[cellId];
      if (!cell) continue;
      cell.process();
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/cell_manager/cell_manager.js